module.exports = __webpack_public_path__ + "static/media/favorite_on.b6119445.svg";